const _import = require('./_import_' + process.env.NODE_ENV);

export default [
  {
    path: '/personal',
    name: 'Personal',
    component: _import('manage/index'),
    children: [
      // 个人用户
      {
        // 个人中心
        path: 'center',
        name: 'PersonalCenter',
        component: _import('manage/personal-center')
      },
      {
        // 关注我的
        path: 'care',
        name: 'PersonalCare',
        component: _import('manage/personal-care')
      },
      {
        // 收藏信息
        path: 'collect',
        name: 'PersonalCollect',
        component: _import('manage/personal-collect')
      },
      {
        // 账号设置
        path: 'config',
        name: 'PersonalConfig',
        component: _import('manage/personal-config')
      },
      {
        // 账号设置
        path: 'config/:index',
        name: 'PersonalConfigWithIndex',
        component: _import('manage/personal-config')
      },
      {
        // 我的简历
        path: 'resume',
        name: 'PersonalResume',
        component: _import('manage/personal-resume')
      },
      {
        // 投递记录
        path: 'send-log',
        name: 'PersonalSendLog',
        component: _import('manage/personal-send-log')
      },
      {
        // 发布招聘
        path: 'recruit',
        name: 'PersonalRecruit',
        component: _import('manage/personal-recruit')
      },
      {
        // 面试邀请
        path: 'interview',
        name: 'PersonalInterview',
        component: _import('manage/personal-interview/index')
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/personal.router.js